module.exports = __webpack_public_path__ + "static/media/iphone_13_pro_alpine_green.55e3e7ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_13_pro_alpine_green.png
// module id = 2116
// module chunks = 0